import React from 'react';
import { BadgeProps } from '../../libs/types/src';

const Badge: React.FC<BadgeProps> = ({ label, color, bg }) => {
    return (
        <span className="demos-badge" style={{ background: bg, color }}>{label}</span>
    );
};

export default Badge; 